import fr from 'facet-rest';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { DataValueMap } from 'Helpers/Testing';

const BillingDetailsProfileSubpageRenewalDate = ({ resource }) => {
  return (
    <Typography
      variant={'h5'}
      color={'darkGray'}
      weight={'medium'}
      {...DataValueMap.init('billing-details-profile-subpage-renewal-date').build()}
    >
      {resource.attr('renewalDateInfo')}
    </Typography>
  );
};

BillingDetailsProfileSubpageRenewalDate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
BillingDetailsProfileSubpageRenewalDate.defaultProps = {};

export default BillingDetailsProfileSubpageRenewalDate;
